/* eslint-disable no-undef */
import React, {useCallback, useContext, useEffect} from 'react';
import { useNavigate } from "react-router-dom";

import './Login.scss'
import {Button, Form, Link, PasswordInput, TextInput} from "@carbon/react";
import backgroundImg from '../../images/grd-login-background.jpg';

import {useRecoilState, useRecoilValue} from "recoil";
import { grpcAuthServiceSelector } from "../../state/grpc"
import { loginFormState } from "../../state/login"

import Card from "../../components/Card";
import AuthContext from "../../components/Auth";

const Login = () => {
  const navigate = useNavigate();
  const authService = useRecoilValue(grpcAuthServiceSelector)
  const [{username, password, loading, error}, setLoginForm] = useRecoilState(loginFormState);
  const authCtx = useContext(AuthContext);

  const navigateToHomepage = useCallback(() => {
    navigate('/')
  }, [navigate])

  useEffect(() => {
    if (authCtx.isLoggedIn) {
      navigateToHomepage()
    }
  }, [navigateToHomepage, authCtx]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const req = new proto.api.LoginRequest();
    req.setUsername(username)
    req.setPassword(password)
    setLoginForm({username: username, password: password, error: '', loading: true})
    authService.login(req, null, (err, resp) => {
      if (err != null) {
        handleError(err)
      } else if (resp != null && resp.array.length > 0) {
        handleLogin(resp.toObject().accessToken, resp.toObject().refreshToken)
      }
    })
  };

  const handleError = (error) => {
    console.warn(error)
    setLoginForm({username: '', password: '', error: "credenziali non valide", loading: false})
  }

  const handleLogin = (token, refreshToken) => {
    setLoginForm({username: '', password: '', error: null, loading: false})
    authCtx.onLogin(token, refreshToken)
    navigateToHomepage()
  }

  return (
    <div className="login__main" style={{backgroundImage: `url(${backgroundImg})`}}>
      <div className="login__right-pane" >
        <Card className="login">
          <p>Guardian 2.0</p>
          <h2>Log in</h2>
          <Form onSubmit={handleSubmit}>
            <div className="login__control">
              <TextInput
                id="username"
                required
                placeholder="Username"
                labelText=""
                value={username}
                onChange={ev => setLoginForm({username: ev.target.value, password, loading: false, error: ''})}
              />
            </div>
            <div className="login__control">
              <PasswordInput
                type="password"
                id="password"
                required
                placeholder="Password"
                labelText=""
                value={password}
                onChange={ev => setLoginForm({username, password: ev.target.value, loading: false, error: ''})}
              />
            </div>
            <div className="login__error">
              <span>{error}</span>
            </div>
            <div className="login__button">
              <Button disabled={loading} type="submit">{loading ? "Accesso in corso.." : "Accedi"}</Button>
            </div>
            <div className="login__register">
              <span>Non hai un account?  <Link to="#">Invia richiesta</Link></span>
            </div>
          </Form>
        </Card>
      </div>
    </div>
  )
}

export default Login